/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/AIMedicalNotes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   AI Medical Notes redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Thursday, June 22, 2023 - 12:05 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/06/22  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  voterName: "",
  voterRaw: "",
  issueArray: [],
  candidateArray: [],
  activeBox: null,
  error: null,
};

const updateFieldReducer = (state, action, field) => {
  if (action.payload !== null) {
    state[field] = action.payload[field];
    state.error = null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

const updateFieldArray = (state, action, field) => {
  if (action.payload !== null) {
    state[field] = [...state[field], action.payload];
    state.error = null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

const replaceFieldArrayItem = (state, action, field) => {
  const { i, text } = action.payload;
  if (state[field][i]) {
    state[field] = state[field].map((item, index) => (index === i ? { text } : item));
    state.error = null;
  } else {
    state.error = `No item at index ${i} to replace.`;
  }
};

const clearFieldArray = (state, action, field) => {
  state[field] = [];
  state.error = null;
};

export const aiMedicalNotesSlice = createSlice({
  name: "aiMedicalNotes",
  initialState,
  reducers: {
    updateVoterName: (state, action) => updateFieldReducer(state, action, "voterName"),
    updateVoterRaw: (state, action) => updateFieldReducer(state, action, "voterRaw"),
    updateIssueArray: (state, action) => updateFieldReducer(state, action, "issueArray"),
    updateCandidateArray: (state, action) => updateFieldReducer(state, action, "candidateArray"),
    clearIssueArray: (state, action) => clearFieldArray(state, action, "issueArray"),
    clearCandidateArray: (state, action) => clearFieldArray(state, action, "candidateArray"),
    replaceIssueArrayItem: (state, action) => replaceFieldArrayItem(state, action, "issueArray"),
    replaceCandidateArrayItem: (state, action) => replaceFieldArrayItem(state, action, "candidateArray"),
  },
});

export const {
  updateVoterName,
  updateVoterRaw,
  updateIssueArray,
  updateCandidateArray,
  clearIssueArray,
  clearCandidateArray,
  replaceIssueArrayItem,
  replaceCandidateArrayItem,
} = aiMedicalNotesSlice.actions;

export default aiMedicalNotesSlice.reducer;
